import { Mm100Page } from '@/components/calculators/power-kits';
import Image from '@/components/UI/Image';
import FixedCalculatorFooter from '@/componentsH5/calculators/components/FixedCalculatorFooter';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export const types_car = [
    { key: 'classA', img: '/img/calculators/mm100H5/step2-classA.jpg', i18n: 'classA' },
    { key: 'classB', img: '/img/calculators/mm100H5/step2-classB.jpg', i18n: 'classB' },
    { key: 'classC', img: '/img/calculators/mm100H5/step2-classC.jpg', i18n: 'classC' },
    { key: 'trailer', img: '/img/calculators/mm100H5/step2-trailer.jpg', i18n: 'trailer' },
];

export const types_house = [
    { key: '15m', img: '/img/calculators/mm100H5/step2-15m.jpg', i18n: '15m' },
    { key: '30m', img: '/img/calculators/mm100H5/step2-30m.jpg', i18n: '30m' },
    { key: '45m', img: '/img/calculators/mm100H5/step2-45m.jpg', i18n: '45m' },
];

export default function Step2H5({ data, callBack }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('shared');
    const [active, setActive] = useState(data?.type || '');

    const types = data?.scene === 'rv' ? types_car : data?.scene === 'house' ? types_house : [];

    const chooseType = (key: string) => {
        if (active !== key) {
            callBack({
                type: key,
                stepTitle: [data.stepTitle[0], key, ...data.stepTitle.slice(-5)],
            });
            setActive(key);
        }
    };

    const onNext = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator2',
            step: 'type',
            product_name: 'Ecoflow Power Kits',
            option_name: active,
            button_name: 'Next',
        });
        callBack({
            currentStep: data.currentStep + 1,
            currentPage: Mm100Page.Appliances,
            type: active,
        });
    };

    const onBack = () => {
        callBack({
            currentStep: data.currentStep - 1,
            currentPage: Mm100Page.Scenery,
            type: null,
            stepTitle: [data.stepTitle[0], 'type', ...data.stepTitle.slice(-5)],
        });
    };
    return (
        <div className={`step2H5 ${css.step2H5}`}>
            <h2 className="step2-title">{data?.scene === 'rv' ? t('calculators.mm100.step2.title_RV') : t('calculators.mm100.step2.title_offGrid')}</h2>
            <ul className="step2-types">
                {types?.map((type: any) => (
                    <div
                        className={`step2-type ${data?.scene === 'rv' ? 'type-rv' : 'type-offGrid'} ${active === type.key ? 'active' : ''}`}
                        key={type.key}
                        onClick={() => chooseType(type.key)}
                    >
                        <div className="img-item">
                            <Image
                                src={type?.img}
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step2.${type.i18n}`)}
                                aria-label={t(`calculators.mm100.step2.${type.i18n}`)}
                            />
                        </div>
                        {active === type.key && (
                            <div className="checkIcon">
                                <Image
                                    src="/img/calculators/mm100/selected.svg"
                                    layout="fill"
                                    className="fullImgs"
                                    alt={t(`calculators.mm100.step2.${type.i18n}`)}
                                    aria-label={t(`calculators.mm100.step2.${type.i18n}`)}
                                />
                            </div>
                        )}
                        <p className="type-name">{t(`calculators.mm100.step2.${type.i18n}`)}</p>
                    </div>
                ))}
            </ul>
            <FixedCalculatorFooter>
                <button className={`step3H5-prevBtn step2Btn commonPrev`} onClick={onBack} aria-label={t('calculators.mm100.back')}>
                    {t('calculators.mm100.back')}
                </button>
                <button
                    className={`step3H5-nextBtn step2Btn commonNext ${active ? 'active' : ''}`}
                    onClick={onNext}
                    disabled={!active}
                    aria-label={t('calculators.mm100.next')}
                >
                    {t('calculators.mm100.next')}
                </button>
            </FixedCalculatorFooter>
        </div>
    );
}
